import request from '@/utils/request'

export function login(data, callId = null, callArgs = {}) {
  return request({
    callId: callId,
    callArgs: callArgs,
    url: '/user/token',
    method: 'post',
    data
  })
}

export function repLogin(data, callId = null, callArgs = {}) {
  return request({
    callId: callId,
    callArgs: callArgs,
    url: `/user/rep_token?rep=${data.rep}`,
    method: 'post',
    data
  })
}

// 微信回调登录
export async function wxCallbackLogin(data) {
  const bd_sem_timestamp = parseInt(localStorage.getItem('bd_sem_timestamp'))
  const bd_vid = localStorage.getItem('bd_vid')
  const bd_ch = localStorage.getItem('bd_ch')

  return await request({
    method: 'POST',
    url: `/user/wxgzh_login?uuid=${data.uuid}&code=${data.code}&state=${data.state}&bd_vid=${bd_vid}&bd_ch=${bd_ch}&bd_sem_timestamp=${bd_sem_timestamp}`
  })
}

export async function pollLogin(uuid) {
  return await request({
    method: 'GET',
    url: `/user/poll_login?uuid=${uuid}`
  })
}

export async function wxCallbackBind(data, callId = null, callArgs = {}) {
  return await request({
    callId: callId,
    callArgs: callArgs,
    method: 'POST',
    url: `/user/wxgzh_bind?uuid=${data.uuid}&code=${data.code}&state=${data.state}&token=${data.token}`
  })
}

export async function pollBind(uuid) {
  return await request({
    method: 'GET',
    url: `/user/poll_bind?uuid=${uuid}`
  })
}

export function getUserInfo(callId = null, callArgs = {}) {
  return request({
    callId: callId,
    callArgs: callArgs,
    url: '/user/me',
    method: 'get'
  })
}

export function updateMe(data, callId = null, callArgs = {}) {
  console.log(data)
  return request({
    callId: callId,
    callArgs: callArgs,
    url: `/user/update_me`,
    method: 'POST',
    data
  })
}

export function logout(callId = null, callArgs = {}) {
  return request({
    callId: callId,
    callArgs: callArgs,
    url: '/user/logout',
    method: 'post'
  })
}

export function register(data, callId = null, callArgs = {}) {
  const bd_sem_timestamp = parseInt(localStorage.getItem('bd_sem_timestamp'))
  const bd_vid = localStorage.getItem('bd_vid')
  const bd_ch = localStorage.getItem('bd_ch')

  return request({
    callId: callId,
    callArgs: callArgs,
    url: `/user/register?bd_vid=${bd_vid}&bd_ch=${bd_ch}&bd_sem_timestamp=${bd_sem_timestamp}`,
    method: 'post',
    data
  })
}

export function resetPassword(data, callId = null, callArgs = {}) {
  return request({
    callId: callId,
    callArgs: callArgs,
    url: '/user/reset_password',
    method: 'post',
    data
  })
}

export async function getWxsdksign(data, callId = null, callArgs = {}) {
  return await request({
    callId: callId,
    callArgs: callArgs,
    method: 'POST',
    url: `/user/wxsdksign?fronturl=${data.fronturl}`
  })
}
